import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const Fallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  padding: 2rem;
  text-align: center;
  font-family: "Quicksand", sans-serif;
`;

const Message = styled.p`
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
`;

const TryAgainButton = styled.button`
  padding: 1rem 2rem;
  border: 0;
  border-radius: 16px;
  font-family: "Quicksand", sans-serif;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: white;
  background: #8747d4;
  cursor: pointer;

  &:hover {
    background: #9859e0;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Unhandled render error:", error, errorInfo);
  }

  handleRetry() {
    this.setState({ hasError: false });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Fallback>
        <Message>Something went wrong.</Message>
        <TryAgainButton onClick={this.handleRetry}>Try again</TryAgainButton>
      </Fallback>
    );
  }
}

/**
 * Keying the boundary on the current path makes it remount on navigation, so a user who
 * lands on the fallback is never stuck there — moving to any other screen clears it.
 */
export default function RouteErrorBoundary({ children }) {
  const location = useLocation();
  return <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>;
}
